//# sourceMappingURL=proposal.mjs.map
/// <reference types="./proposal.d.mts" />
import * as $html_parser from "../../../../data_types/common/html_parser.mjs";
import * as $user_id from "../../../../data_types/data/auth/user_id.mjs";
import * as $proposal from "../../../../data_types/data/proposal.mjs";
import * as $proposal_element from "../../../../data_types/data/proposal_element.mjs";
import * as $answer from "../../../../data_types/data/proposal_element/answer.mjs";
import * as $question from "../../../../data_types/data/proposal_element/question.mjs";
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $user from "../../../../data_types/data/user.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $events from "../../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { px } from "../../../../sketch/sketch/css/length.mjs";
import * as $html from "../../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $levenshtein from "../../../../tiamat/gleam/levenshtein.mjs";
import { levenshtein } from "../../../../tiamat/gleam/levenshtein.mjs";
import * as $timestamp_ from "../../../../tiamat/gleam/time/timestamp_.mjs";
import * as $answer_effects from "../../../admin/effects/answer.mjs";
import * as $proposal_effects from "../../../admin/effects/proposal.mjs";
import * as $store from "../../../data/store.mjs";
import { Ok, toList, Empty as $Empty, prepend as listPrepend, isEqual } from "../../../gleam.mjs";
import * as $versioning_common from "../../../view/project/versioning/common.mjs";

function proposal_actions(proposal) {
  return $l.row(
    toList([$l.align("center"), $l.gap(12)]),
    toList([]),
    toList([
      $h.text(
        (() => {
          let _pipe = proposal.created_at;
          return $timestamp_.to_date_yyyymmdd(_pipe, "/");
        })(),
      ),
      $html.a(
        $css.class$(toList([$css.text_decoration("none"), $css.color("black")])),
        toList([$a.href("/proposal/translations/" + proposal.id)]),
        toList([
          $button.secondary(toList([]), toList([$h.text("Translations")])),
        ]),
      ),
    ]),
  );
}

function user_name(usr, users) {
  if (users instanceof $remote.NotLoaded) {
    return $skeleton.custom(px(200), px(40));
  } else if (users instanceof $remote.Loading) {
    return $skeleton.custom(px(200), px(40));
  } else if (users instanceof $remote.Errored) {
    return $skeleton.custom(px(200), px(40));
  } else {
    let users$1 = users[0];
    let _block;
    let _pipe = users$1;
    let _pipe$1 = $list.find(
      _pipe,
      (user) => { return usr === $user_id.to_string(user.id); },
    );
    _block = $option.from_result(_pipe$1);
    let user = _block;
    return $versioning_common.text(
      (() => {
        let _pipe$2 = user;
        let _pipe$3 = $option.map(_pipe$2, (u) => { return u.name; });
        return $option.unwrap(_pipe$3, "");
      })(),
    );
  }
}

function version_and_writing(a, restore) {
  let _block;
  if (restore instanceof $option.Some) {
    let fn_ = restore[0];
    _block = $button.secondary(
      toList([$events.on_click((_) => { return fn_(); })]),
      toList([
        (() => {
          let _pipe = $icons.refresh_line();
          return $icons.small(_pipe);
        })(),
      ]),
    );
  } else {
    _block = $h.none();
  }
  let refresh_button = _block;
  let _block$1;
  let _block$2;
  let $ = a.metadata.writing_method;
  if ($ instanceof $answer.HumanWritting) {
    _block$2 = $icons.add_user();
  } else if ($ instanceof $answer.AiFirstGeneration) {
    _block$2 = $icons.sparkles();
  } else if ($ instanceof $answer.AiImprove) {
    _block$2 = $icons.gear();
  } else if ($ instanceof $answer.Rollback) {
    _block$2 = $icons.refresh_line();
  } else {
    _block$2 = $icons.external_link();
  }
  let _pipe = _block$2;
  _block$1 = $icons.medium(_pipe);
  let icon = _block$1;
  return $l.column(
    toList([$l.gap(8), $l.justify("center"), $l.align("center")]),
    toList([]),
    toList([
      $versioning_common.text(
        (() => {
          let _pipe$1 = a.version;
          return $int.to_string(_pipe$1);
        })(),
      ),
      icon,
      refresh_button,
    ]),
  );
}

function text_line(text) {
  return $html.div(
    $css.class$(toList([$css.text_decoration("line-through")])),
    toList([]),
    toList([$h.text(text)]),
  );
}

function value_and_initial(answer) {
  let _block;
  let _pipe = answer.value;
  let _pipe$1 = $string.trim(_pipe);
  _block = $html_parser.clean_html_string(_pipe$1);
  let value = _block;
  let _block$1;
  let _pipe$2 = answer.init_value;
  let _pipe$3 = $option.map(_pipe$2, $html_parser.clean_html_string);
  let _pipe$4 = $option.unwrap(_pipe$3, "");
  _block$1 = $string.trim(_pipe$4);
  let initial = _block$1;
  let $ = levenshtein(value, initial);
  let d = $;
  if (d < 10) {
    return $versioning_common.text(value);
  } else {
    return $l.column(
      toList([$l.gap(24)]),
      toList([]),
      toList([text_line(initial), $versioning_common.text(value)]),
    );
  }
}

function answer_row(answer, answers, users, migrate, rollback) {
  let answers$1 = $list.sort(
    answers,
    (a1, a2) => { return $int.compare(a2.version, a1.version); },
  );
  if (answers$1 instanceof $Empty) {
    return toList([
      $table.row(
        toList([
          $table.cell($versioning_common.text("")),
          $table.cell($versioning_common.text(answer.id)),
          $table.cell($versioning_common.text("")),
          $table.cell(value_and_initial(answer)),
          $table.cell($versioning_common.text("")),
          $table.cell($versioning_common.text("")),
          $table.cell($versioning_common.text("")),
          $table.cell(
            $button.primary(
              toList([$events.on_click((_) => { return migrate(); })]),
              toList([$versioning_common.text("migrate")]),
            ),
          ),
        ]),
      ),
    ]);
  } else {
    let first = answers$1.head;
    let rest = answers$1.tail;
    return listPrepend(
      $table.row(
        toList([
          $table.cell($versioning_common.text("")),
          $table.cell($versioning_common.text(answer.id)),
          $table.cell($versioning_common.text("")),
          $table.cell(value_and_initial(answer)),
          $table.cell(version_and_writing(first, new $option.None())),
          $table.cell(
            $versioning_common.text(
              (() => {
                let _pipe = first.value;
                return $html_parser.clean_html_string(_pipe);
              })(),
            ),
          ),
          $table.cell(user_name(first.metadata.editor, users)),
          $table.cell($versioning_common.text("")),
        ]),
      ),
      $list.map(
        rest,
        (a) => {
          return $table.row(
            toList([
              $table.cell($versioning_common.text("")),
              $table.cell($versioning_common.text("")),
              $table.cell($versioning_common.text("")),
              $table.cell($versioning_common.text("")),
              $table.cell(
                version_and_writing(a, new $option.Some(rollback(a.id))),
              ),
              $table.cell(
                $versioning_common.text(
                  (() => {
                    let _pipe = a.value;
                    return $html_parser.clean_html_string(_pipe);
                  })(),
                ),
              ),
              $table.cell(user_name(a.metadata.editor, users)),
              $table.cell($versioning_common.text("")),
            ]),
          );
        },
      ),
    );
  }
}

function question_row(question, answers, users, migrate, rollback) {
  let _block;
  if (users instanceof $remote.NotLoaded) {
    _block = $skeleton.custom(px(200), px(40));
  } else if (users instanceof $remote.Loading) {
    _block = $skeleton.custom(px(200), px(40));
  } else if (users instanceof $remote.Errored) {
    _block = $skeleton.custom(px(200), px(40));
  } else {
    let users$1 = users[0];
    let _block$1;
    let _pipe = question.owner;
    _block$1 = $option.then$(
      _pipe,
      (u) => {
        let _pipe$1 = users$1;
        let _pipe$2 = $list.find(
          _pipe$1,
          (user) => { return isEqual(u, user.id); },
        );
        return $option.from_result(_pipe$2);
      },
    );
    let user = _block$1;
    _block = $versioning_common.text(
      (() => {
        let _pipe$1 = user;
        let _pipe$2 = $option.map(_pipe$1, (u) => { return u.name; });
        return $option.unwrap(_pipe$2, "");
      })(),
    );
  }
  let user = _block;
  return listPrepend(
    $table.row(
      toList([
        $table.cell(
          $versioning_common.text(
            (() => {
              let _pipe = question.created_at;
              return $timestamp_.to_date_yyyymmdd(_pipe, "/");
            })(),
          ),
        ),
        $table.cell(user),
        $table.cell(
          $versioning_common.text(
            (() => {
              let _pipe = $question.numbering(question);
              let _pipe$1 = $option.unwrap(_pipe, toList([]));
              return $string.join(_pipe$1, " ");
            })(),
          ),
        ),
        $table.cell(
          $versioning_common.text(
            (() => {
              let _pipe = question.content;
              return $html_parser.clean_html_string(_pipe);
            })(),
          ),
        ),
        $table.cell($versioning_common.text("")),
        $table.cell($versioning_common.text("")),
        $table.cell($versioning_common.text("")),
      ]),
    ),
    (() => {
      let _pipe = question.answer;
      let _pipe$1 = $dict.values(_pipe);
      return $list.flat_map(
        _pipe$1,
        (answer) => {
          let answers$1 = $list.filter(
            answers,
            (a) => { return a.answer_id === answer.id; },
          );
          return answer_row(
            answer,
            answers$1,
            users,
            migrate(answer.id),
            rollback(answer.id),
          );
        },
      );
    })(),
  );
}

function element_row(element, answers, users, migrate, rollback) {
  if (element instanceof $proposal_element.Question) {
    let question = element.question;
    return question_row(question, answers, users, migrate, rollback);
  } else if (element instanceof $proposal_element.Table) {
    let table = element.table;
    return toList([]);
  } else if (element instanceof $proposal_element.Block) {
    let block = element.block;
    return toList([]);
  } else {
    let outline = element.outline;
    return toList([]);
  }
}

function elements_table(elements, answers, users, migrate, rollback) {
  return $table.table(
    toList([]),
    toList([
      $table.headers(
        toList([
          (() => {
            let _pipe = $table.header("Updated at");
            return $table.clamp(_pipe, "150px", 300);
          })(),
          (() => {
            let _pipe = $table.header("Editor");
            return $table.clamp(_pipe, "150px", 300);
          })(),
          (() => {
            let _pipe = $table.header("");
            return $table.clamp(_pipe, "50px", 300);
          })(),
          (() => {
            let _pipe = $table.header("QnA");
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = $table.header("");
            return $table.clamp(_pipe, "50px", 300);
          })(),
          (() => {
            let _pipe = $table.header("AnswerV2");
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = $table.header("Editor");
            return $table.clamp(_pipe, "150px", 300);
          })(),
          $table.header("to V2"),
        ]),
      ),
      $table.body(
        $list.flat_map(
          elements,
          (element) => {
            let element_id = $proposal_element.id(element);
            return element_row(
              element,
              answers,
              users,
              migrate(element_id),
              rollback,
            );
          },
        ),
      ),
    ]),
  );
}

function migration_bar(proposal_id, elements, answers, dispatch) {
  let _block;
  let _pipe = answers;
  _block = $list.map(_pipe, (answer_v2) => { return answer_v2.answer_id; });
  let migrated_ids = _block;
  let to_migrate = $list.flat_map(
    elements,
    (el) => {
      if (el instanceof $proposal_element.Question) {
        let question = el.question;
        let _pipe$1 = question.answer;
        let _pipe$2 = $dict.values(_pipe$1);
        return $list.filter(
          _pipe$2,
          (answer_v1) => { return !$list.contains(migrated_ids, answer_v1.id); },
        );
      } else {
        return toList([]);
      }
    },
  );
  let count = $list.length(to_migrate);
  let by_kind = $list.group(
    to_migrate,
    (answer_v1) => { return answer_v1.kind; },
  );
  let count_kind = (kind) => {
    let $ = $dict.get(by_kind, kind);
    if ($ instanceof Ok) {
      let items = $[0];
      return $list.length(items);
    } else {
      return 0;
    }
  };
  let yes_no_count = count_kind(new $question.YesNo());
  let mc_count = count_kind(new $question.MultipleChoice());
  let long_count = count_kind(new $question.Long());
  return $l.row(
    toList([$l.align("start"), $l.gap(12)]),
    toList([]),
    toList([
      $button.primary(
        toList([
          $events.on_click(
            (_) => {
              let _pipe$1 = $answer_effects.migrate_proposal_answers(
                proposal_id,
              );
              dispatch(_pipe$1);
              return undefined;
            },
          ),
          $a.disabled(count === 0),
        ]),
        toList([$h.text("Migrate all")]),
      ),
      $l.column(
        toList([$l.gap(4)]),
        toList([]),
        toList([
          $versioning_common.text($int.to_string(count) + " answers to migrate"),
          $h.ul(
            toList([]),
            toList([
              $h.li(
                toList([]),
                toList([
                  $versioning_common.text(
                    $int.to_string(yes_no_count) + " YesNo",
                  ),
                ]),
              ),
              $h.li(
                toList([]),
                toList([
                  $versioning_common.text(
                    $int.to_string(mc_count) + " MultipleChoice",
                  ),
                ]),
              ),
              $h.li(
                toList([]),
                toList([
                  $versioning_common.text($int.to_string(long_count) + " Long"),
                ]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

export function view() {
  return $redraw.component_(
    "ProposalVersioning",
    (proposal_id) => {
      let store = $store.use_state();
      let dispatch = $store.use_effect_dispatch();
      let users = $store.organization_users(store);
      $redraw.use_effect(
        () => {
          let $ = (() => {
            let _pipe = store.proposal_elements;
            return $dict.get(_pipe, proposal_id);
          })();
          if ($ instanceof Ok) {
            return undefined;
          } else {
            let _pipe = $proposal_effects.fetch_proposal_elements(proposal_id);
            dispatch(_pipe);
            let _pipe$1 = $answer_effects.fetch_answers(proposal_id);
            dispatch(_pipe$1);
            return undefined;
          }
        },
        [store.proposal_elements],
      );
      let migrate = (element_id) => {
        return (answer_id) => {
          return () => {
            let _pipe = $answer_effects.migrate_answer(
              proposal_id,
              element_id,
              answer_id,
            );
            dispatch(_pipe);
            return undefined;
          };
        };
      };
      let rollback = (answer_id) => {
        return (version_id) => {
          return () => {
            let _pipe = $answer_effects.rollback_answer(
              proposal_id,
              answer_id,
              version_id,
            );
            dispatch(_pipe);
            return undefined;
          };
        };
      };
      let $ = store.proposals;
      if ($ instanceof $remote.NotLoaded) {
        return $l.column(
          toList([$l.gap(48)]),
          toList([]),
          listPrepend(
            $skeleton.custom(px(800), px(120)),
            $list.repeat($skeleton.custom(px(1200), px(80)), 10),
          ),
        );
      } else if ($ instanceof $remote.Loading) {
        return $l.column(
          toList([$l.gap(48)]),
          toList([]),
          listPrepend(
            $skeleton.custom(px(800), px(120)),
            $list.repeat($skeleton.custom(px(1200), px(80)), 10),
          ),
        );
      } else if ($ instanceof $remote.Errored) {
        return $l.column(
          toList([$l.gap(48)]),
          toList([]),
          listPrepend(
            $skeleton.custom(px(800), px(120)),
            $list.repeat($skeleton.custom(px(1200), px(80)), 10),
          ),
        );
      } else {
        let pagination = $[0];
        let _block;
        let $1 = (() => {
          let _pipe = pagination.elements;
          return $list.find(_pipe, (p) => { return p.id === proposal_id; });
        })();
        let $2 = (() => {
          let _pipe = store.proposal_elements;
          return $dict.get(_pipe, proposal_id);
        })();
        let $3 = (() => {
          let _pipe = store.answers;
          return $dict.get(_pipe, proposal_id);
        })();
        if ($1 instanceof Ok) {
          if ($2 instanceof Ok && $3 instanceof Ok) {
            let proposal = $1[0];
            let elements = $2[0];
            let answers = $3[0];
            _block = toList([
              $versioning_common.proposal_title(
                proposal.name,
                proposal_actions(proposal),
              ),
              migration_bar(proposal_id, elements, answers, dispatch),
              elements_table(elements, answers, users, migrate, rollback),
            ]);
          } else {
            let proposal = $1[0];
            _block = listPrepend(
              $versioning_common.proposal_title(
                proposal.name,
                proposal_actions(proposal),
              ),
              $list.repeat($skeleton.custom(px(1200), px(80)), 10),
            );
          }
        } else {
          _block = listPrepend(
            $skeleton.custom(px(800), px(120)),
            $list.repeat($skeleton.custom(px(1200), px(80)), 10),
          );
        }
        let _pipe = _block;
        return ((_capture) => {
          return $l.column(
            toList([$l.gap(48), $l.styles(toList([$css.z_index(8000)]))]),
            toList([]),
            _capture,
          );
        })(_pipe);
      }
    },
  );
}
